import { Flex } from "@/components/layout/flexbox";
import { Filter } from "@/components/pieces/filter/Filter";
import { FilterButton } from "@/components/pieces/filter/FilterButton";
import { Tab } from "@/types/tabs";

interface MobileViewTabsProps {
  tabs: Tab[];
  currentTab: Tab;
  onTabChange: (path: string) => void;
}

export function MobileViewTabs({
  tabs,
  currentTab,
  onTabChange,
}: MobileViewTabsProps) {
  return (
    <Flex py={3} alignItems="center" justifyContent="center">
      <Filter
        button={
          <FilterButton rightIcon="chevron-down" text={currentTab.label} />
        }
        options={tabs.map((link) => ({
          id: link.path ?? "",
          name: link.label,
        }))}
        selectedOptions={[
          { id: currentTab.path ?? "", name: currentTab.label },
        ]}
        onFilterChange={(option) =>
          option.id !== currentTab.path && onTabChange(option.id)
        }
        viewMode="none"
        fullHeight={true}
      />
    </Flex>
  );
}
